import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const reattributePolicies = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'policies.reattribute');
